import { Component } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

import { TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'ldw-static-text',
  templateUrl: './static-text.component.html',
  styleUrls: ['./static-text.component.css'],
  imports: [MatFormField, MatIcon, MatPrefix, ReactiveFormsModule, MatTooltip, MatInput]
})
export class StaticTextComponent extends BaseEdit {}
